import { TipoVisibilita } from "src/app/common/models/tipologiche/tipo-visibilita"

export class TipiVisibilita {

    /**
     * 
     * @param role 
     * @returns Array of TipoVisibilita
     */
    public getTipiVisibilitaByRoleType(role:string): Array<TipoVisibilita> {
        const TIPI_VISIBILITA = {
            "RISERVATISSIMA" : [
                {
                    "id": "4dff7133-ca47-406e-825a-1ddee66244d8",
                    "descrizione": "Grado di riservatezza di livello riservatissimo",
                    "label": "RISERVATISSIMA",
                    "rimosso": false
                },
                {
                    "id": "87aed441-2dba-4c83-9a58-d287d5f49bbb",
                    "descrizione": "Grado di visibilit&#225; di livello riservato",
                    "label": "RISERVATA",
                    "rimosso": false
                },
                {
                    "id": "df2bf50c-a8bd-4c49-b4a5-baa7679efa83",
                    "descrizione": "Grado di riservatezza di livello pubblico",
                    "label": "PUBBLICA",
                    "rimosso": false
                }
            ],
            "RISERVATA" : [
                {
                    "id": "87aed441-2dba-4c83-9a58-d287d5f49bbb",
                    "descrizione": "Grado di visibilit&#225; di livello riservato",
                    "label": "RISERVATA",
                    "rimosso": false
                },
                {
                    "id": "df2bf50c-a8bd-4c49-b4a5-baa7679efa83",
                    "descrizione": "Grado di riservatezza di livello pubblico",
                    "label": "PUBBLICA",
                    "rimosso": false
                }
            ],
            "default" : [
                {
                    "id": "df2bf50c-a8bd-4c49-b4a5-baa7679efa83",
                    "descrizione": "Grado di riservatezza di livello pubblico",
                    "label": "PUBBLICA",
                    "rimosso": false
                }
            ]
        }
        return TIPI_VISIBILITA[role] || TIPI_VISIBILITA["default"];
    }
}